export default "__VITE_ASSET__30d3d3a4__"